import { withStyles, TableCell } from '@material-ui/core'

const style = theme => ({
  sizeSmall: {
    padding: theme.spacing(1)
  }
})

export default withStyles(style)(TableCell)
